<template>
  <div>
    <v-data-table
      height="22vh"
      fixed-header
      hide-no-data
      disable-sort
      hide-default-footer
      class="soil-block-table mt-3 ml-2"
      density="compact"
    >
      <template v-slot:bottom> </template>
      <template v-slot:thead>
        <thead>
          <tr>
            <th class="pl-1 pr-1">#</th>
            <th class="pl-1 pr-1" style="padding-left: 8px !important">Soil type</th>
            <th class="pl-1 pr-1" style="padding-left: 8px !important">MV={{ groundLevel }}+NAP</th>
            <th class="pl-1 pr-1">
              <ActionBar
                :disabled="readonly"
                show-add
                @add="addSoilProfilePoint({ soil_profile: profileId, z: 0 })"
              />
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:tbody>
        <NoDataInDataTable :colspan="500" :show="showNoData" />
        <tbody>
          <tr
            v-for="(item, index) in items"
            :key="`point-${item.id}`"
            @contextmenu.prevent="readonly || show($event, item)"
          >
            <td class="pa-0" style="width: 5%">
              <div>
                <span style="font-size: 14px">
                  {{ index + 1 }}
                </span>
              </div>
            </td>
            <td class="pa-0" style="width: 60%">
              <DropDownSoilType
                :items="
                  getBaseSoilTypeItemsByRevision(currentStabSchematisationStage.soiltyperevision)
                "
                :item="item.base_soil_type"
                :basic="true"
                @set="
                  (value) =>
                    setParameterSoilProfilePoint({
                      value: value,
                      item: item,
                      parameter: 'base_soil_type'
                    })
                "
                @addDirty="addDirty(item, 'base_soil_type')"
                :class="[
                  getDirtyClass(item, 'base_soil_type'),
                  emptyField(item.soil_type),
                  readonly ? 'disable-events' : '',
                  'pa-0 fill-height'
                ]"
              />
            </td>
            <td class="pa-0" style="width: 20%">
              <DataTableField
                @update="addDirty(item, 'z')"
                @set="setParameterSoilProfilePoint"
                :item="item"
                :dirtyClass="getDirtyClass(item, 'z')"
                parameter="z"
              />
            </td>
            <td class="pa-0" style="width: 15%"></td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <TableActionMenu
      @update:show-menu="showMenu = $event"
      :selected-item="selectedItem"
      :show-menu="showMenu"
      :x="x"
      :y="y"
      @action="deleteSoilProfilePointItem(selectedItem.id)"
      @add="addSoilProfilePoint({ soil_profile: profileId, z: selectedItem.z })"
    />
  </div>
</template>
<script>
import DropDownSoilType from '@/components/form/DropDownSoilType.vue'
import TableActionMenu from '@/components/common/TableActionMenu.vue'
import ShowActionMenuMixin from '@/mixins/ShowActionMenuMixin.vue'
import DirtyFieldsMixIn from '@/mixins/DirtyFieldsMixIn.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import NoDataInDataTable from '@/components/common/NoDataInDataTable.vue'
import ActionBar from '@/components/common/ActionBar.vue'
import DataTableField from '@/components/form/DataTableField.vue'

export default {
  name: 'SoilProfileBlockTable',
  components: {
    ActionBar,
    DropDownSoilType,
    TableActionMenu,
    NoDataInDataTable,
    DataTableField
  },
  mixins: [DirtyFieldsMixIn, ShowActionMenuMixin],
  props: {
    items: {},
    groundLevel: {},
    soilType: {},
    profileId: {},
    readonly: { type: Boolean, default: false }
  },
  computed: {
    ...mapState('stabSchematisationStage', {
      currentStabSchematisationStage: (state) => state.currentItem
    }),
    ...mapGetters('baseSoilType', {
      getBaseSoilTypeItemsByRevision: 'getItemsByRevision'
    }),
    showNoData() {
      return this.items ? this.items.length === 0 : true
    }
  },
  methods: {
    ...mapActions('soilProfilePoint', {
      setParameterSoilProfilePoint: 'setParameter',
      addSoilProfilePoint: 'addBlockSoilProfile',
      deleteSoilProfilePointItem: 'deleteItem'
    }),
    emptyField(field) {
      return field === null ? 'border-bottom-red' : ''
    },
    emptyDirtyItemsClass() {
      this.dirtyItems = []
    }
  }
}
</script>
<style>
.soil-block-table > .v-data-table__wrapper {
  overflow-x: hidden !important;
}
</style>
